import React from "react";
import Layout from "./layout";
// import tailoredSolutions from "../Assets/about/undraw_solution_mindset_re_57bf.svg";
// import experts from "../Assets/about/undraw_experts_re_i40h.svg";
// import patners from "../Assets/about/undraw_team_up_re_84ok.svg";
// import excel from "../Assets/about/undraw_details_8k13.svg";
// import impact from "../Assets/about/24372256_6909933.svg";
// import { Link } from "react-router-dom";

function Aboutus() {
  return (
    <Layout>
      {/* 
<!-- Section 2 --> */}
      <div class="py-16 bg-white">
        {/* <div class="container m-auto px-6 text-gray-600 md:px-12 xl:px-6">
          <div class="space-y-6 md:space-y-0 md:flex md:gap-6 lg:items-center lg:gap-12">
            <div class="md:5/12 lg:w-5/12">
              <img
                src="https://tailus.io/sources/blocks/left-image/preview/images/startup.png"
                alt="image"
                loading="lazy"
                width=""
                height=""
              />
            </div>
            <div class="md:7/12 lg:w-6/12">
              <h2 class="text-2xl text-gray-900 font-bold md:text-4xl">
                About Us
              </h2>
              <p class="mt-6 text-gray-600">
                At Workshopbay, we believe in the transformative power of
                education. Our mission is to empower individuals and
                organizations worldwide through high-quality online training
                programs designed to unlock potential and drive success.
              </p>
            </div>
          </div>
        </div> */}

        <div className="bg-emerald-50  flex flex-col items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
          <div className="max-w-8xl w-full space-y-8">
            <div className="bg-emerald-50 shadow-md rounded-lg p-8">
              <div className="space-y-6">
                {/* <section className="">
                  <div className="py-12 bg-white">
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                      <div className="mt-10">
                        <dl className="space-y-10 md:space-y-0 md:grid md:grid-cols-2 md:gap-x-8 md:gap-y-10">
                          <div className="relative">
                            <dt>
                              <p className="font-heading ml-16 text-lg leading-6 font-bold text-gray-700">
                                Our Impact
                              </p>
                            </dt>
                            <dd className="mt-2 ml-16 text-base text-gray-500">
                              We provide a vibrant online learning platform with
                              a diverse range of courses designed to equip you
                              with the skills and knowledge you need to succeed.
                              Our satisfied learners have used our training.
                            </dd>
                          </div>
                          <div className="relative">
                            <dt>
                              <p className="font-heading ml-16 text-lg leading-6 font-bold text-gray-700">
                                The Problem We Solve
                              </p>
                            </dt>
                            <dd className="mt-2 ml-16 text-base text-gray-500">
                              {" "}
                              In today's rapidly changing world, traditional
                              learning methods can feel restrictive. We
                              understand the challenges of busy schedules,
                              geographical limitations, and the need for
                              flexible learning options
                            </dd>
                          </div>
                          <div className="relative">
                            <dt>
                              <p className="font-heading ml-16 text-lg leading-6 font-bold text-gray-700">
                                Meet the Experts
                              </p>
                            </dt>
                            <dd className="mt-2 ml-16 text-base text-gray-500">
                              {" "}
                              Our team is comprised of passionate instructors
                              and industry veterans with a wealth of experience.
                              You can learn more about our team on our dedicated
                              page!
                            </dd>
                          </div>
                          <div className="relative">
                            <dt>
                              <p className="font-heading ml-16 text-lg leading-6 font-bold text-gray-700">
                                Learning Designed for You
                              </p>
                            </dt>
                            <dd className="mt-2 ml-16 text-base text-gray-500">
                              {" "}
                              We believe in engaging and interactive online
                              training. Whether you're a visual learner, an
                              auditory learner, or a hands-on learner, we have a
                              training approach that caters to your style.
                            </dd>
                          </div>
                        </dl>
                      </div>
                    </div>
                  </div>
                </section> */}
                <div>
                  <h4 className=" text-gray-800">
                    Welcome to Workshopbay - Empowering Your Learning Journey
                  </h4>
                  <p className="mt-2 text-gray-600">
                    At Workshopbay, we believe that learning is the key to
                    personal and professional growth. Our passion lies in
                    providing accessible and innovative online training
                    solutions to help individuals and organizations thrive in an
                    ever-changing world.
                  </p>
                </div>
                <div>
                  <h4 className=" text-gray-800">Our Philosophy</h4>
                  <p className="mt-2 text-gray-600">
                    We are committed to excellence in education, driven by the
                    belief that everyone deserves the opportunity to learn and
                    succeed. Through our diverse range of courses and dynamic
                    learning experiences, we strive to inspire curiosity, foster
                    creativity, and ignite the desire for lifelong learning.
                  </p>
                </div>

                <div>
                  <h4 className=" text-gray-800">Our Commitment</h4>
                  <p className="mt-2 text-gray-600">
                    When you choose [Firm Name], you're not just enrolling in a
                    course; you're joining a community of learners committed to
                    personal and professional development. We are dedicated to
                    your success and will work tirelessly to provide you with
                    the tools, resources, and support you need to achieve your
                    goals.
                  </p>
                </div>

                <div>
                  <h4 className=" text-gray-800">What Sets Us Apart</h4>
                  <p className="mt-2 text-gray-600">
                    <ul>
                      <li>
                        • Expertise: Our courses are developed and delivered by
                        industry experts and experienced educators who are
                        dedicated to sharing their knowledge and insights.
                      </li>
                      <li>
                        • Engagement: We leverage interactive technologies and
                        multimedia resources to create engaging and immersive
                        learning experiences that captivate and inspire.
                      </li>
                      <li>
                        • Flexibility: With anytime, anywhere access to our
                        courses, you can learn at your own pace and fit your
                        studies around your busy schedule.
                      </li>
                      <li>
                        <li>
                          • Flexibility: With anytime, anywhere access to our
                          courses, you can learn at your own pace and fit your
                          studies around your busy schedule.
                        </li>
                      </li>
                    </ul>
                  </p>
                </div>

                <div>
                  <h4 className=" text-gray-800">Get Started Today</h4>
                  <p className="mt-2 text-gray-600">
                    Ready to embark on your learning journey? Browse our course
                    catalog, explore our offerings, and take the first step
                    towards achieving your goals with Workshopbay.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default Aboutus;
